/** Calendar-month bounds shared by projection generation and the timeline. */
export function cadenceWindow(reference: Date): { start: number; end: number } {
  const shifted = (months: number) => {
    const date = new Date(reference);
    const day = date.getUTCDate();
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() + months);
    const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(day, lastDay));
    return date.getTime();
  };
  return { start: shifted(-18), end: shifted(6) };
}
